module.exports = __webpack_public_path__ + "img/item-2(1920)new.9d9e7729.jpg";